import SwitchWithLoader from "Components/CustomComponents/SwitchWithLoader";
import React from "react";
import { Spinner } from "react-bootstrap";
import { LogoutIcon } from "svg";

interface SettingButtonsProps {
  text: string;
  bgColor?: string;
  textColor?: string;
  hasButton?: boolean;
  isLogout?: boolean;
  isChecked?: boolean;
  isLoading?: boolean;
  clickHandler?: () => void;
}

const SettingButtons: React.FC<SettingButtonsProps> = ({
  text,
  bgColor = "#F5F5F5",
  textColor = "#323232",
  hasButton = false,
  isLogout = false,
  isChecked = true,
  isLoading = false,
  clickHandler,
}) => {
  return (
    <div
      className="py-3 px-4 rounded-4 w-100 d-flex justify-content-between my-2"
      style={{ backgroundColor: bgColor, color: textColor, height: "64px" }}
      onClick={clickHandler}
    >
      <span className="w-100 align-content-center">{text}</span>
      {hasButton ? (
        isLoading ? (
          <Spinner
            animation="border"
            variant="dark"
            size="sm"
            className="my-auto me-3"
          />
        ) : (
          <SwitchWithLoader isChecked={isChecked} onChange={() => {}} />
        )
      ) : (
        ""
      )}
      {isLogout ? <LogoutIcon /> : ""}
    </div>
  );
};

export default SettingButtons;
